import { render, staticRenderFns } from "./MotherAndBabySign.vue?vue&type=template&id=135dfe98&scoped=true"
import script from "./MotherAndBabySign.vue?vue&type=script&lang=js"
export * from "./MotherAndBabySign.vue?vue&type=script&lang=js"
import style0 from "./MotherAndBabySign.vue?vue&type=style&index=0&id=135dfe98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135dfe98",
  null
  
)

export default component.exports